import { useEffect, useRef } from "react"

import { ErrorMessage, MessageList, PanelContainer } from "./styles"

import ChatHeader from "./ChatHeader"
import ChatInput from "./ChatInput"
import ChatMessage from "./ChatMessage"
import TripSummaryCard from "./TripSummaryCard"
import TypingIndicator from "./TypingIndicator"

const ChatPanel = ({ messages, isStreaming, error, tripData, onSend, onStop, onClear, onClose, onTripFilled }) => {
   const listRef = useRef(null)

   useEffect(() => {
      if (listRef.current) {
         listRef.current.scrollTop = listRef.current.scrollHeight
      }
   }, [messages, isStreaming])

   return (
      <PanelContainer>
         <ChatHeader onClose={onClose} onClear={onClear} />
         <MessageList ref={listRef}>
            {messages.map((msg, idx) => {
               if (msg.role === "assistant" && !msg.content && isStreaming && idx === messages.length - 1) {
                  return <TypingIndicator key={idx} />
               }
               if (!msg.content) return null
               return <ChatMessage key={idx} message={msg} />
            })}
            {error && <ErrorMessage>{error}</ErrorMessage>}
            {tripData && <TripSummaryCard tripData={tripData} onFilled={onTripFilled} />}
         </MessageList>
         <ChatInput onSend={onSend} onStop={onStop} isStreaming={isStreaming} />
      </PanelContainer>
   )
}

export default ChatPanel
